export function getLanguageCode(language) {
	let code
	if (language === 'en') {
    code = 'en-gb'
  } else if (language === 'es') {
    code = 'es-MX'
  }

	return code
}